<section class="admin-form-section">
    <app-admin-form-row [formGroup]="form"
                        label="PROCESS *">
        <div class="em-l-grid__item admin-input-width">
            <app-dropdown [form]="form"
                          [formControlPath]="'process'"
                          [options]="(processes$ | async)"
                          [key]="'id'"
                          [value]="'name'">
            </app-dropdown>
        </div>
    </app-admin-form-row>
    <app-admin-form-row [formGroup]="form"
                        label="TEMPLATE ALIAS">
        <div class="em-l-grid__item admin-input-width">
            <input formControlName="alias"
                   type="text"
                   class="em-c-input em-u-font-style-regular"
                   maxlength="24">
        </div>
    </app-admin-form-row>
    <app-admin-form-row [formGroup]="form"
                        label="PROCEDURE NUMBER">
        <div class="em-l-grid__item admin-input-width em-c-field">
            <input formControlName="procedure"
                   type="text"
                   placeholder="B4P-RXG-XXX.doc"
                   class="em-c-input em-u-font-style-regular">
        </div>
    </app-admin-form-row>
</section>

<section class="admin-form-section">
    <app-admin-form-row [formGroup]="form"
                        label="TEST EQUIPMENT"
                        description="(Choose 'Required' if you want technician to select test equipment before completing the work)">
        <div class="em-l-grid__item admin-input-width">
            <app-options [formGroup]="form"
                         [formControlPath]="'isTestEquipmentRequired'"
                         [defaultOption]="getOption(getFormControl('isTestEquipmentRequired').value, isRequiredOption)"
                         [labelStyle]="'em-u-width-50'"
                         [options]="isRequiredOption"
                         [disabled]="form.disabled"
                         [key]="'key'"
                         [value]="'value'">
            </app-options>
        </div>
    </app-admin-form-row>
    <app-admin-form-row [formGroup]="form"
                        label="TEST DIRECTION">
        <div class="em-l-grid__item admin-input-width">
            <div [formGroup]="form"
                 [ngClass]="{'em-is-disabled': form.disabled}"
                 class="em-c-field">
                <select formControlName="testingDirection"
                        class="em-c-select em-u-width-100">
                    <option *ngFor="let option of testingDirectionOptions"
                            [ngValue]="option.key">
                        {{ option.value }}
                    </option>
                </select>
            </div>

        </div>
    </app-admin-form-row>
</section>

<section class="admin-form-section">
    <app-admin-form-row [formGroup]="getFormGroup('setPoint')"
                        label="SET POINT (CDTP) *">
        <div class="em-l-grid__item admin-input-width">
            <app-dropdown [form]="getFormGroup('setPoint')"
                          [formControlPath]="'unitOfMeasurement'"
                          [options]="(uomList$ | async | filterPercentUom)"
                          [key]="'uomCode'"
                          [value]="mapUomObjToUomDisplay">
            </app-dropdown>
        </div>
        <div [formGroup]="getFormGroup('setPoint')"
             class="em-l-grid__item admin-input-width em-c-field">
            <div class="em-l-grid em-c-field tolerance-input">
                <div class="em-l-grid__item em-u-padding-top-none">
                    <app-numeric-input formControlName="value"
                                       [clearZeroOnFocus]="true">
                    </app-numeric-input>
                </div>
            </div>
        </div>
    </app-admin-form-row>

    <app-admin-form-row [formGroup]="getFormGroup('tolerance')"
                        label="AS FOUND OVERPRESSURE TOLERANCE *">
        <div class="em-l-grid__item admin-input-width">
            <app-dropdown [form]="getFormGroup('tolerance')"
                          [formControlPath]="'unitOfMeasurement'"
                          [options]="toleranceUoMs"
                          [key]="'uomCode'"
                          [value]="mapUomObjToUomDisplay">
            </app-dropdown>
        </div>
        <div class="em-l-grid__item admin-input-width">
            <div class="em-l-grid em-c-field tolerance-input">
                <div class="em-l-grid__item em-u-padding-top-none">
                    <em>-</em>
                    <app-numeric-input [ngModel]="form.get('tolerance.lowerRange').value | absolute"
                                       [ngModelOptions]="{standalone: true}"
                                       [disabled]="form.disabled"
                                       [allowNegative]="false"
                                       (emitWhenInputLosingFocus)="updateToleranceRange($event, 'tolerance', 'lowerRange')"
                                       [clearZeroOnFocus]="true">
                    </app-numeric-input>
                </div>
                <span>To</span>
                <div class="em-l-grid__item em-u-padding-top-none">
                    <em>+</em>
                    <app-numeric-input [ngModel]="form.get('tolerance.higherRange').value | absolute"
                                       [ngModelOptions]="{standalone: true}"
                                       [disabled]="form.disabled"
                                       [allowNegative]="false"
                                       (emitWhenInputLosingFocus)="updateToleranceRange($event, 'tolerance', 'higherRange')">
                    </app-numeric-input>
                </div>
            </div>
        </div>
    </app-admin-form-row>
    <app-admin-form-row [formGroup]="getFormGroup('expectedReading')">
        <div class="em-l-grid__item expected-reading-range">
            <span>Expected: </span>
            <strong>{{ expectedReadingRange }}</strong>
        </div>
    </app-admin-form-row>

    <app-admin-form-row [formGroup]="getFormGroup('asLeftTolerance')"
                        label="AS LEFT SET PRESSURE TOLERANCE *">
        <div class="em-l-grid__item admin-input-width">
            <app-dropdown [form]="getFormGroup('asLeftTolerance')"
                          *appRectGhostLoadingIf="(uomList$ | async)?.length <= 0"
                          [formControlPath]="'unitOfMeasurement'"
                          [options]="asLeftToleranceUoMs"
                          [key]="'uomCode'"
                          [value]="mapUomObjToUomDisplay">
            </app-dropdown>
        </div>
        <div class="em-l-grid__item admin-input-width">
            <div class="em-l-grid em-c-field tolerance-input">
                <div class="em-l-grid__item em-u-padding-top-none">
                    <em>-</em>
                    <app-numeric-input [ngModel]="form.get('asLeftTolerance.lowerRange').value | absolute"
                                       [ngModelOptions]="{standalone: true}"
                                       [disabled]="form.disabled"
                                       [allowNegative]="false"
                                       (emitWhenInputLosingFocus)="updateToleranceRange($event, 'asLeftTolerance', 'lowerRange')"
                                       [clearZeroOnFocus]="true">
                    </app-numeric-input>
                </div>
                <span>To</span>
                <div class="em-l-grid__item em-u-padding-top-none">
                    <em>+</em>
                    <app-numeric-input [ngModel]="form.get('asLeftTolerance.higherRange').value | absolute"
                                       [ngModelOptions]="{standalone: true}"
                                       [disabled]="form.disabled"
                                       [allowNegative]="false"
                                       (emitWhenInputLosingFocus)="updateToleranceRange($event, 'asLeftTolerance', 'higherRange')">
                    </app-numeric-input>
                </div>
            </div>
        </div>
    </app-admin-form-row>
    <app-admin-form-row [formGroup]="getFormGroup('asLeftExpectedReading')">
        <div class="em-l-grid__item expected-reading-range">
            <span>Expected: </span>
            <strong>{{ asLeftExpectedReadingRange }}</strong>
        </div>
    </app-admin-form-row>

    <app-admin-form-row [formGroup]="form"
                        label="SERVICE FLUID">
        <div class="em-l-grid__item admin-input-width em-c-field">
            <app-dropdown-search [displayField]="'serviceFluidName'"
                                 [needEmitEventWhenValidateDataFirstly]="false"
                                 [placeholder]="'Enter Service Fluid'"
                                 [selector]="serviceFluidsSelector"
                                 [control]="getFormControl('serviceFluid')">
            </app-dropdown-search>
        </div>
    </app-admin-form-row>
</section>
